import { Injectable } from '@angular/core';
import { BaseController } from '@app/common/modules/base/base.controller';
import { ServicoExecutadoModel } from '@data/servico-executado/models';
import { ServicoExecutadoRepository } from '@data/servico-executado/servico-executado.repository';

@Injectable()
export class ServicoExecutadoController extends BaseController<ServicoExecutadoModel> {
  constructor(servicoExecutadoRepository: ServicoExecutadoRepository) {
    super(servicoExecutadoRepository);
  }
}
